export default "__VITE_ASSET__B5FoXM03__"